module.exports = __webpack_public_path__ + "img/1-1.3883c460.png";